import React, { useState, useEffect } from "react";
import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { navConfig } from "./NavConfig";
import { Stack } from "@mui/system";
import NotificationsPopover from "../NotificationsPopper";
import AccountPopover from "../AccountPopover";
import { NavLink as RouterLink } from "react-router-dom";
import { StyledNavItemIcon } from "./styles";
import "./style.css";
import { Icon } from "@mui/material";

const drawerWidth = 290;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

// interface AppBarProps extends MuiAppBarProps {
//   open?: boolean;
// }

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function NavSection() {
  const theme = useTheme();
  const [open, setOpen] = useState("");
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    function handleResize() {
      setOpen(window.innerWidth < 786 ? false : true);
    }

    window.addEventListener("resize", handleResize);
    handleResize(); // Call handleResize initially to set the initial screen size
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Box>
      <CssBaseline />
      <AppBar
        style={{ height: "64px", backgroundColor: "white" }}
        position="fixed"
        open={open}
        className="header"
      >
        <Stack
          direction="row"
          alignItems="center"
          spacing={{
            xs: 0.5,
            sm: 2,
          }}
          justifyContent="space-between"
          style={{ margin: "10px 40px 10px 20px" }}
        >
          <Stack direction={"row"}>
            <IconButton
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{
                marginRight: 5,
                ...(open && { display: "none" }),
              }}
            >
              <Icon icon="quill:hamburger-sidebar" />
            </IconButton>
          </Stack>
          <Stack direction={"row"} spacing={2} sx={{ marginRight: "15px" }}>
            <NotificationsPopover />
            <AccountPopover />
          </Stack>
        </Stack>
      </AppBar>
      <Drawer variant="permanent" className="navBar" open={open}>
        <DrawerHeader sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box></Box>
          <Box>
            <img
              src="assets/images/meon-logo.png"
              width={"150px"}
              style={{ textAlign: "center" }}
              alt=""
            />
          </Box>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <Icon icon="ic:baseline-arrow-right" />
            ) : (
              <Icon icon="ic:twotone-arrow-left" />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List sx={{ flexGrow: 1 }}>
          {navConfig.map((item, index) => (
            <ListItem
              component={RouterLink}
              to={item.path}
              key={item.id}
              disablePadding
              sx={{
                display: "block",
                color: "black",
                "&.active": {
                  color: "#185CB6",
                  fontWeight: "bold",
                  bgcolor: "#F6FAFF",
                  borderLeft: "2px solid",
                },
              }}
            >
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <StyledNavItemIcon>{item.icon && item.icon}</StyledNavItemIcon>
                {/* </ListItemIcon> */}
                <ListItemText
                  disableTypography
                  primary={item.title && item.title}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>
          ))}
          <Divider />
        </List>
     
      </Drawer>
    </Box>
  );
}
